<!--
 * @Description: 合作伙伴新增 [基本信息-base ，对接人信息，市场活动信息]
 * @Author: cxh
 * @Date: 2022-06-13 16:21:49
 * @LastEditTime: 2023-06-16 16:05:26
 * @LastEditors: cxh
-->
<template>
  <a-form name="detailsForm" ref="baseFormRef" :model="form">
    <dc-layout-card title="跟进记录">
      <dc-form-item label="客户名称" name="followRefId" :rules="[{ required: true, message: '请选择' }]">
        <ClueAndCustomerSelect
          appId="cos_fbu"
          v-model:value="form.followRefId"
          v-model:label="form.customerName"
          :disabled="disabled || (route.query.followRefId || route.query.planId ? true : false)"
          @change="changeCus"
          :view="view"
        />
        <template #label>
          客户名称
          <a-tooltip placement="top" v-if="form.preFollowRefName">
            <template #title> 通过{{ form.preFollowRefName }}客户合并； </template>
            <!-- <img src="@/assets/index/iconoir_puzzle.svg" class="mask-eye" style="position: relative; top: -2px" /> -->
            <message-outlined style="margin-left: 4px" />
          </a-tooltip>
        </template>
      </dc-form-item>
      <dc-form-item label="完成访客计划" name="planId">
        <CosSelect
          v-model:value="form.planId"
          :fieldNames="{
            label: 'title',
            value: 'id'
          }"
          placeholder="请选择"
          :options="visitPlanData"
          :disabled="disabled || route.query.planId ? true : false"
          :view="view"
        />
      </dc-form-item>

      <dc-form-item label="跟进时间" name="startTime" :rules="[{ required: true, message: '请选择' }]">
        <CosSingleDateTimePicker
          v-model:startTime="form.startTime"
          v-model:endTime="form.endTime"
          :isRange="true"
          :disabled="disabled"
          :view="view"
          :disabled-date="disabledDate"
          @change="getSignInList"
        />
      </dc-form-item>
      <dc-form-item
        name="contactId"
        label="联系人"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择', trigger: 'change' }]"
      >
        <CosSelect
          v-model:value="form.contactId"
          :fieldNames="{
            label: 'name',
            value: 'id'
          }"
          allowClear
          placeholder="请选择"
          @change="changeContactId"
          :options="followUpOptions.contactList"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="目的"
        name="fbuPurpose"
        :rules="[
          { required: true, validator: selectForNumberValidate, message: '请选择' },
          {
            validator: purposeByAlarmValidate,
            trigger: 'blur'
          }
        ]"
      >
        <ParamCodesSelect
          :options="paramCodeData.fbu_follow_purpose"
          v-model:value="form.fbuPurpose"
          v-model:label="form.fbuPurposeTxt"
          :disabled="disabled"
          @change="changePurpose"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="跟进方式"
        name="mode"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <ParamCodesSelect
          :options="paramCodeData.fbu_follow_mode"
          v-model:label="form.fbuFollowTxt"
          v-model:value="form.mode"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="关联商机"
        name="chanceId"
        :rules="[
          {
            required: chanceIdRequired,
            message: '请选择'
          }
        ]"
      >
        <BusinessName appId="cos_fbu" v-model:value="form.chanceName" v-if="view" />
        <CosSelect
          v-else
          filterNoVal
          v-model:value="form.chanceId"
          allowClear
          placeholder="请选择"
          :disabled="disabled"
          :view="view"
        >
          <a-select-option v-for="item in saleChanceData" :key="item.chanceId" :disabled="item.disabled">
            <BusinessName appId="cos_fbu" v-model:value="item.saleChanceName" />
          </a-select-option>
        </CosSelect>
      </dc-form-item>
      <dc-form-item name="fbuAssistPersons" label="协同人">
        <user-select v-model:value="form.fbuAssistPersons" :disabled="disabled" mode="multiple" :view="view" />
      </dc-form-item>
      <dc-form-item
        label="拜访签到记录"
        name="signInId"
        :rules="[
          {
            required: form.fbuFollowTxt === '上门拜访' ? true : false,
            message: '请选择',
            validator: selectForNumberValidate
          }
        ]"
      >
        <CosSelect
          v-model:value="form.signInId"
          :view="view"
          :viewOptions="signInListOptions"
          :viewFieldNames="{ label: 'signInTime', value: 'id' }"
        >
          <a-select-option v-for="item in signInListOptions" :key="item.id" :value="item.id">
            <p :title="item.signInTime">{{ item.signInTime }}</p>
            <p :title="item.customerAddress" style="color: #999">{{ item.customerAddress }}</p>
          </a-select-option>
          <template #view="{ option }">
            <a-tooltip placement="topLeft" color="rgba(19, 32, 67, 0.9)" v-if="option && option.customerAddress">
              <template #title>
                <p>{{ option.customerAddress }}</p>
              </template>
              <div>
                {{ option.signInTime || option.id }}
                <environment-outlined />
              </div>
            </a-tooltip>
            <p v-else>{{ option.signInTime || option.id || '--' }}</p>
          </template>
        </CosSelect>
      </dc-form-item>
      <template v-if="disabled">
        <dc-form-item label="跟进人">
          <CosInput v-model:value="form.dutyByName" :view="view" placeholder="请输入" :disabled="disabled" />
        </dc-form-item>
        <dc-form-item label="创建人">
          <CosInput v-model:value="form.createByName" :view="view" placeholder="请输入" :disabled="disabled" />
        </dc-form-item>
        <dc-form-item label="创建时间">
          <CosInput v-model:value="form.createTime" :view="view" placeholder="请输入" :disabled="disabled" />
        </dc-form-item>
      </template>
      <!---异动详情----->
      <a-col :span="24">
        <AlarmList
          :cosId="form.followRefId"
          :followId="form.id"
          v-model:alarmHasMain="form.alarmHasMain"
          v-model:value="form.alarmProcess"
          ref="alarmListFromRef"
          :view="view"
        />
      </a-col>
      <dc-form-item label="具体详情" name="process" :span="24" :rules="[{ required: true, message: '请输入' }]">
        <Editor
          :maxlength="30000"
          :disabled="disabled"
          :placeholder="editorPlaceholder"
          v-model:value="form.process"
          v-model:mention="form.userCodes"
        />
      </dc-form-item>
      <dc-form-item label="上传附件" name="fileId" :span="24" v-if="!disabled || form.fileId">
        <UploadFile :disabled="disabled" v-model:value="form.fileId" valueType="array" :view="view" />
      </dc-form-item>
    </dc-layout-card>
    <!---只有新增才显示访客计划、销售商机----->
    <template
      v-if="route.path.includes('/fbu/followUpRecord/add') || route.path.includes('/fbu/followUpRecord/visitingPlan')"
    >
      <div class="page-card">
        <div class="dc-card-header">
          <div class="dc-card-header-defaut">
            <div class="dc-card-header-defaut-line"></div>
            <p>访客计划</p>
            <div class="dc-card-header-defaut-subtitle">
              <a-button danger @click="hasplay = false" v-if="hasplay">取消</a-button>
              <a-button type="primary" @click="addVisitPlan" ghost v-else>新增</a-button>
            </div>
          </div>
        </div>
        <VisitorProgramForm
          ref="visitorProgramFormRef"
          type="add"
          v-if="hasplay"
          :saleChanceRefId="form.followRefId || '--'"
          v-model:value="form.visitPlanList"
        />
      </div>
      <div class="paddingLine"></div>
      <!------->
      <div class="dc-card-header">
        <div class="dc-card-header-defaut">
          <div class="dc-card-header-defaut-line"></div>
          <p>商机</p>
          <div class="dc-card-header-defaut-subtitle">
            <a-button danger @click="hasSaleChance = false" v-if="hasSaleChance">取消</a-button>
            <a-button type="primary" @click="addSaleChance" ghost v-else>新增</a-button>
          </div>
        </div>
      </div>
      <BusinessForm
        ref="saleChanceFormRef"
        type="add"
        v-if="hasSaleChance"
        v-model:value="form.saleChance"
        :saleChanceRefId="form.followRefId || '--'"
      />
    </template>
  </a-form>
  <cos-footer-button
    v-if="!disabled"
    v-model:value="form"
    :workCode="form.dutyBy"
    :formRef="baseFormRef"
    :resetValue="resetValue"
    :loading="loading"
    @submit="handleSubmit"
    @reset="handleReset"
    @validate="validate"
    :disabled="disabled"
    :permissionPage="permissionPage"
  >
  </cos-footer-button>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, watch, PropType, onActivated, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Editor from '@/components/Editor'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import UploadFile from '@/components/UploadFile'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import BusinessForm from '@/views/gucangSales/chanceManage/business/components/BusinessForm.vue'
import AlarmList from './alarmList.vue'
import VisitorProgramForm from '../../components/VisitorProgramForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { signInRecordListByCosId, listByParamCodes } from '@/api/common'
import {
  followRecordsAddByMess,
  followRecordsAddOrUpdate,
  followRecordsDetail,
  followRecordsDate
  // visitorProgramDetail
} from '@/api/gucangSales/followUpManage'
import type { Rule } from 'ant-design-vue/es/form'
import type { FbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { DcMessage, DcConfirm, message } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import { cloneDeep } from 'lodash-es'
import dayjs, { Dayjs } from 'dayjs'
import { selectForNumberValidate } from '@/utils/validate'
import { MessageOutlined, EnvironmentOutlined } from '@ant-design/icons-vue'
import { paramCodesDataFilter } from '@/utils/index'
import { potentialArchive } from '@/api/gucangSales/customerCenter'
import router from '@/router'
import { Modal as AModal } from 'ant-design-vue/lib/components'
const route = useRoute()
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<FbuFollowUpRecordEdit>
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  view: {
    type: Boolean
  },
  hideOk: {
    type: Boolean
  },
  archiveIds: {
    type: Array
  }
})
const editorPlaceholder =
  '1. 过程<br />2. 结果<br />3. 后续<br />4.具体原因<br />5.处理方法<br />6.遇到得问题及需要得帮助 '
const signInListOptions = ref()
const baseFormRef = ref()
const saleChanceFormRef = ref()
const visitorProgramFormRef = ref()
const alarmListFromRef = ref()

const form = ref<any>({
  saleChance: {},
  visitPlanList: {}
})
const resetValue = ref<FbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: {}
})
const hasSaleChance = ref(false)
const hasplay = ref(false)
const loading = ref(false)
const startDate = ref(dayjs(new Date()).subtract(3, 'day').endOf('day'))
const getSignInList = async () => {
  try {
    const startTime = dayjs(form.value.startTime).format('YYYY/MM/DD') + ' 00:00:00'
    const endTime = dayjs(form.value.startTime).format('YYYY/MM/DD') + ' 23:59:59'

    const res: any = await signInRecordListByCosId({ cosId: form.value.followRefId, signInId: form.value.signInId, startTime: startTime, endTime: endTime })
    signInListOptions.value = res.data
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const paramCodeData = ref<{
  fbu_follow_mode: []
  fbu_follow_purpose: []
}>({
  fbu_follow_mode: [], // 拜访方式
  fbu_follow_purpose: [] // 访客目的
})
const followUpOptions = reactive<{
  contactList: any[]
  saleChanceList: any[]
  visitPlanList: any[]
}>({
  contactList: [],
  saleChanceList: [],
  visitPlanList: []
})
const disabledDate = (current: Dayjs) => {
  return current > dayjs(new Date()) || current < startDate.value
}
// 商机必填校验
const chanceIdRequired = computed(() => {
  if (form.value.fbuPurposeTxt === '处理异常' || form.value.fbuPurposeTxt === '客情维护') {
    return false
  }
  if (form.value.fbuPurposeTxt === '深耕商机') {
    return true
  }
  if (!saleChanceData.value || !saleChanceData.value.length) {
    return false
  }
  return true
})
// 有一二级异动信息存在时，目的只能选择【处理异动】
const purposeByAlarmValidate = async (rule: Rule, value: string) => {
  const { alarmHasMain, fbuPurposeTxt } = form.value
  if (alarmHasMain && fbuPurposeTxt && fbuPurposeTxt !== '处理异动') {
    return Promise.reject(new Error('一二级异动信息存在时，目的只能选择【处理异动】'))
  } else {
    return Promise.resolve()
  }
}
// 处理访客计划数据(只处理详情)
const visitPlanData = computed(() => {
  const { planId, planTitle } = form.value
  const { visitPlanList } = followUpOptions
  if (planId && planTitle && route.query.id) {
    const obj = visitPlanList.find((item: any) => item.id === planId)
    if (!obj) {
      visitPlanList.unshift({
        id: planId,
        title: planTitle,
        disabled: true
      })
    }
  }
  return visitPlanList
})
// 处理商机数据(只处理详情)
const saleChanceData = computed(() => {
  const { chanceId, chanceName, fbuPurposeTxt } = form.value
  const { saleChanceList } = followUpOptions
  // 深耕商机 可以选择5未能合作与6达成合作商机
  let newSaleChanceList = cloneDeep(saleChanceList)
  if (fbuPurposeTxt !== '深耕商机') {
    newSaleChanceList = saleChanceList.filter((v: any) => v.status !== 6 && v.status !== 7 && v.status !== 8)
  }
  if (chanceId && chanceName && (route.query.id || route.query.planId)) {
    const obj = newSaleChanceList.find((item: any) => item.chanceId === chanceId)
    if (!obj) {
      newSaleChanceList.unshift({
        chanceId: chanceId,
        saleChanceName: chanceName,
        disabled: true
      })
    }
  }
  return newSaleChanceList
})
// 目的修改
const changePurpose = (v: string) => {
  nextTick(() => {
    const { fbuPurposeTxt, chanceId } = form.value
    if (fbuPurposeTxt !== '深耕商机' && chanceId) {
      const obj = saleChanceData.value.find((item) => item.chanceId === chanceId)
      if (!obj || (obj && obj.disabled)) {
        form.value.chanceId = undefined
      }
    }
  })
}
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      form.value = v
      resetValue.value = cloneDeep(v)
    }
  },
  { immediate: true }
)
const emit = defineEmits(['getDetail'])
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    followRecordsDetail(route.query.id)
      .then((res) => {
        form.value = {
          ...res.data
        }
        emit('getDetail', res.data)
        resetValue.value = cloneDeep(res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_follow_mode', 'fbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}
// 获取跟进记录日期
const getDate = () => {
  followRecordsDate().then((res) => {
    if (res.data) {
      startDate.value = dayjs(res.data)
    }
  })
}
// 获取客户相关信息（访客计划，联系人，商机）
const getMessage = () => {
  if (form.value.followRefId) {
    followRecordsAddByMess({
      followRefId: form.value.followRefId
    }).then((res) => {
      const { contactList, saleChanceList, visitPlanList } = res.data
      followUpOptions.contactList = contactList && contactList.length ? contactList : []
      followUpOptions.saleChanceList = saleChanceList && saleChanceList.length ? saleChanceList : []
      followUpOptions.visitPlanList = visitPlanList && visitPlanList.length ? visitPlanList : []
      // 设置联系人默认值
      if (contactList && contactList.length === 1) {
        if (!form.value.contactId) {
          form.value = {
            ...form.value,
            contactId: contactList[0].id,
            contactName: contactList[0].name
          }
          // resetValue.value = cloneDeep(form.value)
        }
      }
    })
  }
  getSignInList()
}

// 客户修改
const changeCus = (v: any) => {
  form.value = {
    ...form.value,
    followRefId: v,
    contactId: undefined,
    contactName: undefined,
    planId: undefined,
    chanceId: undefined,
    saleChance: {
      ...form.value.saleChance,
      saleChanceRefId: v
    },
    visitPlanList: {
      ...form.value.visitPlanList,
      visitRefId: v,
      chanceId: undefined
    }
  }
}
// 回显数据监听客户名称变化
watch(
  () => form.value.followRefId,
  (val) => {
    if (val) {
      getMessage()
    }
  },
  { immediate: true }
)
watch(
  () => form.value.alarmHasMain,
  (val) => {
    if (val) {
      // 设置默认值
      const purpose: any = paramCodeData.value.fbu_follow_purpose?.find((item: any) => item.cnName === '处理异动')
      if (purpose && (!form.value.fbuPurpose || form.value.fbuPurpose === -9)) {
        form.value.fbuPurpose = purpose.id
        form.value.fbuPurposeTxt = '处理异动'
      }
    }
  },
  { immediate: true }
)
const changeContactId = (v: any, option: any) => {
  form.value.contactName = option ? option.name : undefined
}
// 提交表单
const submitSure = async () => {
  // 处理联系人
  const p = {
    ...form.value,
    saleChance: hasSaleChance.value ? form.value.saleChance : undefined,
    visitPlanList: hasplay.value ? [form.value.visitPlanList] : undefined
  }
  loading.value = true
  try {
    const data = await followRecordsAddOrUpdate(p, { custom: { errorMsg: false } })
    if (data.code === 200) {
      if (route.query.planId) {
        message.success('已完成拜访')
        goBack()
      } else if (route.query.id) {
        message.success('编辑成功')
        goBack()
      } else {
        if (props.archiveIds) {
          potentialArchive({ cosIdList: [props.archiveIds] }).then(() => {
            message.success('新增跟进且置为归档成功')
            goBack()
          })
        } else {
          message.success('新增成功')
          goBack()
        }
      }
    } else if (data.code === 17000016) {
      AModal.warning({
        closable: true,
        title: '操作提示！',
        content: '签约/成交客户至少要有一个商机才能录入跟进记录,是否立即添加？',
        cancelText: '取消',
        okCancel: true,
        okText: '继续',
        onOk() {
          router.push({
            path: '/fbu/business/add',
            query: {
              saleChanceRefId: route.query.followRefId
            }
          })
        }
      })
    } else {
      message.error(data.message)
    }
  } catch (error) {}
  loading.value = false
}

const handleSubmit = async () => {
  const alarmListFromRefVali = alarmListFromRef.value?.validate()
  const baseFormRefVali = baseFormRef.value?.validate()
  const saleChanceFormRefVali = saleChanceFormRef.value?.validate()
  const visitorProgramFormRefVali = visitorProgramFormRef.value?.validate()
  Promise.all([baseFormRefVali, saleChanceFormRefVali, visitorProgramFormRefVali, alarmListFromRefVali]).then(
    async (res) => {
      // 当异动说明选择【已流失】选项时，提交时需弹框提示【已流失客户请及时申请终止合作流程】
      const { alarmProcess } = form.value
      if (alarmProcess && alarmProcess.batch && alarmProcess.batch.length) {
        const hasLast = alarmProcess.batch.find((item: any) => item.alarmDescText?.join('').includes('已流失'))
        if (hasLast) {
          DcConfirm.warning({
            title: '操作提示！',
            content: '已流失客户请及时申请终止合作流程',
            cancelText: '取消',
            okText: '继续',
            onOk() {
              submitSure()
            }
          })
          return
        }
      }
      submitSure()
    }
  )
}

// 重置访客计划、商机表单
const handleReset = () => {
  hasSaleChance.value = false
  hasplay.value = false
  form.value.saleChance = {}
  form.value.visitPlanList = {}
  alarmListFromRef.value?.reset()
}
// 校验访客计划、商机表单
const validate = () => {
  saleChanceFormRef.value?.validate()
  alarmListFromRef.value?.validate()
  visitorProgramFormRef.value?.validate()
}
// 点击新增访客计划
const addVisitPlan = () => {
  hasplay.value = true
  form.value.visitPlanList = {
    visitRefId: form.value.followRefId
  }
}
// 点击新增销售商机
const addSaleChance = () => {
  hasSaleChance.value = true
  form.value.saleChance = {
    saleChanceRefId: form.value.followRefId
  }
}
const init = () => {
  if (route.query.followRefId) {
    form.value = {
      chanceId: route.query.chanceId as string,
      followRefId: route.query.followRefId as string,
      saleChance: {
        saleChanceRefId: route.query.followRefId
      },
      visitPlanList: {
        visitRefId: route.query.followRefId
      }
    }
    resetValue.value = cloneDeep(form.value)
  }
  fetch()
  getByParamCodes()
}
onMounted(() => {
  init()
  getDate()
})
// 缓存
onActivated(() => {
  getMessage()
  getDate()
})
</script>
<script lang="ts">
export default { name: 'BaseMessage' }
</script>
<style scoped>
.paddingLine {
  height: 12px;
  margin-left: -20px;
  margin-right: -20px;
  bottom: 0;
  background: #f9f9ff;
  margin-bottom: 16px;
}
</style>
